export default __webpack_public_path__ + "static/media/business_card_landscape_90x55mm.65f56fd5.png";